import { render, staticRenderFns } from "./TilesResultsExtended.vue?vue&type=template&id=f7a1edc4&"
import script from "./TilesResultsExtended.vue?vue&type=script&lang=js&"
export * from "./TilesResultsExtended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports